<template>
  <div class="col-sm-12 text-right">
    <button
      :class="act == 1 ? actv : ''"
      class="btn btn-sm"
      @click="[filterBy(1), setActive(1)]"
    >
      Today
    </button>
    <button
      :class="act == 7 ? actv : ''"
      class="btn btn-sm"
      @click="[filterBy(7), setActive(7)]"
    >
      This Week
    </button>
    <button
      :class="act == 30 ? actv : ''"
      class="btn btn-sm"
      @click="[filterBy(30), setActive(30)]"
    >
      This Month
    </button>
    <date-picker
      @change="[getRange(), setActive(0)]"
      :placeholder="placeholder"
      v-model="range"
      range
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  data() {
    return {
      actv: "actvbtn",
      actvBorder: "mx-input",
      act: 1,
      range: "",
      startDt: "",
      endDt: "",
      day: "today",
      custom: false,
      // placeholder : 'Custom ate'
    };
  },
  computed: {
    placeholder() {
      if (this.$route.query.days == 0) {
        return `${moment(this.$route.query.from).add(330,'minutes')
          .format("DD-MM-YYYY")} ~ ${moment(this.$route.query.to)
          .add(330,'minutes')
          .format("DD-MM-YYYY")}`;
      } else return "Custom Date";
    },
  },
  props: {
    filter: {
      type: Object,
      default: function () {
        return {
          custom: false,
          days: 1,
          from: moment().startOf("month").format().split("+")[0],
          to: moment().format().split("+")[0],
        };
      },
    },
  },
  components: { DatePicker },
  methods: {
    setActive(num) {
      this.act = num;
    },
    filterBy(num) {
      if (num == 1) {
        this.act = 1;
        this.startDt = moment()
          .startOf("day")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.endDt = moment().endOf("day").utc().format("YYYY-MM-DD HH:mm:ss");
        this.day = "today";
      } else if (num == 7) {
        this.act = 7;
        this.startDt = moment()
          .startOf("week")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.endDt = moment().endOf("week").utc().format("YYYY-MM-DD HH:mm:ss");
        this.day = "this week";
      } else if (num == 30) {
        this.act = 30;
        this.startDt = moment()
          .startOf("month")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.endDt = moment()
          .endOf("month")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.day = "this month";
      }
      this.$emit("timeFrameEmit", {
        custom: this.custom,
        num,
        startDt: this.startDt,
        endDt: this.endDt,
        day: this.day,
      });
    },
    getRange() {
      this.startDt = moment
        .parseZone(this.range[0])
        .startOf("day")
        .subtract(330, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      this.endDt = moment
        .parseZone(this.range[1])
        .endOf("day")
        .subtract(330, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      this.day = "in the selected range";
      this.custom = true;
      this.$emit("timeFrameEmit", {
        custom: true,
        num: 0,
        startDt: this.startDt,
        endDt: this.endDt,
        day: this.day,
      });
    },
  },
  watch: {
    filter: {
      immediate: false,
      handler(v) {
        if (!this.filter.custom) {
          this.filterBy(this.filter.days);
        } else {
          this.startDt = this.filter.from;
          this.endDt = this.filter.to;
          this.act = this.filter.days;
        }
      },
    },
  },
};
</script>

<style scoped>
.actvbtn {
  color: #3498db;
}
.mx-datepicker,
.mx-datepicker-range {
  width: 15rem;
  height: calc(1.5em + 0.75rem + 2px);
}
</style>